'use client';

import { useState } from 'react';

import { useDebounce } from 'shared/base';

import { useReactRouterSyncWithUrlParam } from './useReactRouterSyncWithUrlParam';

export function useReactRouterSearchTerm({ suffix }: { suffix?: string } = {}) {
  const [searchTerm, setSearchTerm] = useReactRouterSyncWithUrlParam<string>({
    defaultValue: '',
    paramKey: `searchTerm${suffix ? `-${suffix}` : ''}`,
  });
  const [apiSearchTerm, setApiSearchTerm] = useState(searchTerm);
  const { debouncedFunc: setDebouncedApiSearchTerm } = useDebounce(setApiSearchTerm, 250);

  const handleSetSearchTerm = (value: string) => {
    setSearchTerm(value);
    setDebouncedApiSearchTerm(value);
  };

  return { apiSearchTerm, searchTerm, setSearchTerm: handleSetSearchTerm };
}
